import clsx from 'clsx'
import React, { FC, useContext, useEffect, useState } from 'react'

import ScreenSizeContext from 'context/screenSizeContext'

import { MediaNames } from 'constants/media-constanst'

import styles from './toggle-text-button.module.scss'

interface IToggleButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primaryText: string // Пример: Хочу смотреть/Подробнее
  secondaryTextOn: string // Пример: Подписаться
  secondaryTextOff: string // Пример: Отписаться
  onlyPrimaryStatus?: boolean
  isActive?: boolean
  noIcon?: boolean
}

const ToggleTextButton: FC<IToggleButton> = ({
  isActive,
  primaryText,
  noIcon,
  secondaryTextOn,
  secondaryTextOff,
  onlyPrimaryStatus,
  ...props
}) => {
  const [hovered, setHovered] = useState(false)
  const { windowSize } = useContext(ScreenSizeContext)
  const isMobile = ![MediaNames.PC_MIN, MediaNames.PC_MAX].includes(windowSize)
  const isIconShow = !noIcon

  useEffect(() => {
    if (hovered && isMobile) {
      setHovered(false)
    }
  }, [isMobile, hovered])

  const handleMouseEnter = () => setHovered(true)
  const handleMouseLeave = () => setHovered(false)

  if (onlyPrimaryStatus) {
    return (
      <button
        className={clsx(styles.button, styles.buttonPrimary)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        {...props}
      >
        <div>{primaryText}</div>
      </button>
    )
  }

  return (
    <button
      className={clsx(styles.button, {
        [styles.buttonPrimary as string]: !isActive,
      })}
      // Нужно для корректной работы на мобилке во время ховера/клика
      onMouseEnter={!isMobile ? handleMouseEnter : () => null}
      onMouseLeave={!isMobile ? handleMouseLeave : () => null}
      {...props}
    >
      {isActive ? (
        <>
          {
            <div className={styles.activeBtnText}>
              <div
                className={clsx(styles.fadedText, {
                  [styles.fadeOut as string]: hovered,
                  [styles.fadeIn as string]: !hovered,
                })}
              >
                {secondaryTextOn}
              </div>
              <div
                className={clsx(styles.fadedText, {
                  [styles.fadeOut as string]: !hovered,
                  [styles.fadeIn as string]: hovered,
                  [styles.fadedTextRed as string]: hovered && !isMobile,
                })}
              >
                {secondaryTextOff}
              </div>
              {isIconShow && (
                <div className={styles.iconWrapper}>
                  <div className={styles.iconlineAnim1} />
                  <div className={clsx(styles.iconlineAnim1, styles.iconlineAnim2)} />
                </div>
              )}
            </div>
          }
        </>
      ) : (
        <div>{primaryText}</div>
      )}
    </button>
  )
}

export default ToggleTextButton
